import React, { Component } from "react";




export default class Login extends Component {
  handleLogin = (hospitalID, password)=>
  {
    alert('Login');
    console.log("HI");
    let url = `http://127.0.0.1:8000/apis/hospital-login/username=${hospitalID}/password=${password}>/`;
    fetch(url, {
      mode:'cors',
      method: "get",

    })
    .then((response) => response.json(),

    )


    .then((data) =>
      // alert(data)
      window.location.href = "http://localhost:3000/dashboard"
    )
  }
  render() {
    return (
      <form
          form onSubmit={()=>this.handleLogin(this.refs.id.value, this.refs.pass.value)}

          >

        <h3>Log in</h3>

        <div className="form-group">
          <label>Hospital ID</label>
          <input
            ref = "id"
            type="text"
            className="form-control"
            placeholder="Hospital ID"
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            ref = "pass"
            type="password"
            className="form-control"
            placeholder="Enter password"
          />
        </div>

        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="customCheck1"
            />
            <label className="custom-control-label" htmlFor="customCheck1">
              Remember me
            </label>
          </div>
        </div>

        <button type="submit" className="btn btn-dark btn-lg btn-block" href = "/dashboard">
          Sign in
        </button>
        <p className="forgot-password text-right">
          Forgot <a href="#">password?</a>
        </p>
      </form>
    );
  }
}
